/*
 * @Author: your name
 * @Date: 2022-04-29 16:45:59
 * @LastEditTime: 2022-08-26 15:23:50
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jeecgboot-vue3\src\components\do\index.tsx
 */
import { selectProps } from 'ant-design-vue/es/select';
import { initDefaultProps } from 'ant-design-vue/es/_util/props-util';
import { defineComponent, ref, watch, watchEffect } from 'vue';
import { propTypes } from '/@/utils/propTypes';
import { esHelper } from '/@/utils/http/es_utils/es_helper';
import { TreeSelectProps } from 'ant-design-vue';
import { Plugin } from '@vue/runtime-dom';

const jprops = {
  ...initDefaultProps(selectProps(), {
    listHeight: 256,
    listItemHeight: 24,
  }),
  style: {
    type: Object as PropType<import('vue').CSSProperties>,
  },
  placeholder: {
    type: String,
    default: '请选择',
    required: false,
  },
  pidValue: {
    type: String,
    default: '',
    required: false,
  },
  customSource: propTypes.func,
  labelField: propTypes.string,
  valueField: propTypes.string,
  allowClear: {
    type: Boolean,
    default: false,
    required: false,
  },
};

const comp = defineComponent({
  props: jprops,
  emits: ['update:value', 'change'],
  setup(props, ctx) {
    const data = ref<TreeSelectProps['treeData']>([]);
    const searchValue = ref('');
    const cachePid = ref<string>();
    // const isPropChange = false;
    const meta = ref<any>({
      ...props,
      onChange: (newval) => {
        ctx.emit('update:value', newval); // 返回给调用者
        ctx.emit('change', newval);
      },
      'onUpdate:value': undefined,
    });
    watch(props, () => {
      meta.value = {
        ...props,
        onChange: (newval) => {
          ctx.emit('update:value', newval); // 返回给调用者
          ctx.emit('change', newval);
        },
        'onUpdate:value': undefined,
      };
    });
    // const meta = ref<any>({
    //   ...props,
    //   onChange: (newval) => {
    //     ctx.emit('update:value', newval); // 返回给调用者
    //     ctx.emit('change', newval);
    //   },
    //   'onUpdate:value': undefined,
    // });

    const loadData = async () => {
      if (props.customSource) {
        const res = await props.customSource();
        data.value = res;
      } else {
        if (cachePid.value !== props.pidValue && props.pidValue) {
          cachePid.value = props.pidValue;
          const res = await esHelper.findEnumsTreeByPid(props.pidValue);
          // data.value = res.result.map((r) => ({
          //   value: r.id,
          //   title: r.name,
          // }));
          data.value = convert(res.result);
        }
      }
    };

    const convert = (data) => {
      if (data) {
        return (data = data.map((r) => ({
          value: r.id,
          title: r.name,
          selectable: r.children && r.children.length === 0,
          children: convert(r.children),
        })));
      }

      // data.forEach((e) => {
      //   if (e.children.lenght > 0) {
      //     e.children = convert(e.children);
      //   }
      // });
    };

    watchEffect(async () => {
      if (props.pidValue) {
        await loadData();
      }
    });

    loadData();

    // watch(selectedValue, (returnValue) => {
    //   if (isPropChange) {
    //     isPropChange = false;
    //     return;
    //   }

    // });

    // watch(
    //   () => props.value,
    //   (newVal) => {
    //     if (newVal !== selectedValue.value) {
    //       isPropChange = true;
    //       selectedValue.value = newVal;
    //     }
    //   }
    // );

    return {
      meta,
      searchValue,
      data,
    };
  },
  render() {
    return (
      <>
        <a-tree-select
          {...this.meta}
          allow-clear={this.allowClear}
          value={this.value}
          // v-model:value="value"
          // v-model={[this.selectedValue, 'value']}
          tree-default-expand-all
          v-model:tree-data={this.data}
        ></a-tree-select>
      </>
    );
  },
});

export const DSelectTree: Plugin = {
  install: (app) => {
    // Plugin code goes here
    app.component('DSelectTree', comp);
  },
};
